exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.list .list__item{\n  display:-webkit-box;\n  display:-ms-flexbox;\n  display:flex;\n  padding:.4rem;\n  -webkit-box-align:start;\n      -ms-flex-align:start;\n          align-items:flex-start\n}", ""]);

// exports
